/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import { QuestionnaireInstanceModel } from "../../models/questionnaire-instance-model";

export interface QuestionnaireInstanceInviteGetParams {
    token: string
}

export function questionnaireInstanceInviteGet(http: HttpClient, rootUrl: string, params: QuestionnaireInstanceInviteGetParams, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireInstanceModel>> {
    const rb = new RequestBuilder(rootUrl, questionnaireInstanceInviteGet.PATH, 'get');
    if (params) {
        rb.query('token', params.token);
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<QuestionnaireInstanceModel>;
        })
    );
}

questionnaireInstanceInviteGet.PATH = '/api/v1/questionnaire-instances';
